import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'if-component',
  shadow: false,
})
export class IfComponent {
  @Prop() condition: boolean = false;
  render() {
    return this.condition ? <slot name="then"></slot> : <slot name="else"></slot>;
  }
}
